
		<cache-date></cache-date>
		
		<period></period>
		
		<filterForm [addFilterParams]="filter.addFilterParams"></filterForm>

		<div class="btn-group" role="group">
			<ng-container *ngFor="let value of ['absolute', 'relative']">
				<button type="button" [class]="tariffVariants.chartValue == value ? 'btn btn-light active' : 'btn btn-light'" (click)="changeChartValue('tariffVariants', value)">
					{{ value }}
				</button>
			</ng-container>
		</div>
		<chart [data]="tariffVariants.data" [options]="tariffVariants.options" [sextant]="'tariffVariants'"></chart>
		<hr><br>

		<div class="btn-group" role="group">
			<ng-container *ngFor="let value of ['absolute', 'relative']">
				<button type="button" [class]="tariffIds.chartValue == value ? 'btn btn-light active' : 'btn btn-light'" (click)="changeChartValue('tariffIds', value)">
					{{ value }}
				</button>
			</ng-container>
		</div>
		<chart [data]="tariffIds.data" [options]="tariffIds.options" [sextant]="'tariffIds'"></chart>
		<hr><br>

		<div class="btn-group" role="group">
			<ng-container *ngFor="let value of ['absolute', 'relative']">
				<button type="button" [class]="paymenyType.chartValue == value ? 'btn btn-light active' : 'btn btn-light'" (click)="changeChartValue('paymenyType', value)">
					{{ value }}
				</button>
			</ng-container>
		</div>
		<chart [data]="paymenyType.data" [options]="paymenyType.options" [sextant]="'paymenyType'"></chart>
		<hr><br>
		

		<form class="form-inline">
			<div class="form-group">
				<label>Other</label>
				<input type="number" class="form-control" placeholder="Other" [(ngModel)]="otherBorder" [ngModelOptions]="{standalone: true}" (change)="changeBorder()">
			</div>
		</form>
		<chart [data]="intervals.data" [options]="intervals.options" [sextant]="'intervals'"></chart>
		<hr><br>

		<div class="btn-group" role="group">
			<ng-container *ngFor="let value of ['absolute', 'relative']">
				<button type="button" [class]="currentTariffIds.chartValue == value ? 'btn btn-light active' : 'btn btn-light'" (click)="changeChartValue('currentTariffIds', value)">
					{{ value }}
				</button>
			</ng-container>
		</div>
		<chart [data]="currentTariffIds.data" [options]="currentTariffIds.options" [sextant]="'currentTariffIds'"></chart>
		
		<hr><br><br>
		
		<div [sextant]="'disturbData'">
			<h3>{{ 'adminstat.billing.payment_structure.disturb title' | translate }}</h3>
			<h4>{{ 'adminstat.billing.payment_structure.userWithSiteCount' | translate }}: {{ disturbData.userWithSiteCount }}</h4>
			<h4>{{ 'adminstat.billing.payment_structure.userWithoutSiteCount' | translate }}: {{ disturbData.userWithoutSiteCount }}</h4>
			
			<br>
			<table class="table" >
				<thead>
					<tr>
						<th>{{ 'adminstat.common.siteCount' | translate }}</th>
						<th>{{ 'adminstat.common.userCount' | translate }}</th>
						<th title="('adminstat.billing.payment_structure.disturb title percent' | translate)">%</th>
					</tr>
				</thead>
	
				<tbody *ngIf="disturbData">
					<tr *ngFor="let stat of disturbData.stats">
						<td>{{ stat.siteCount }}</td>
						<td>
							<button-anhor (click)="showDisturbDetails(stat)" [sextant]="'details-' + key">
								{{ stat.userCount }}
							</button-anhor>
						</td>
						<td>{{ stat.percentUserCount }}%</td>
					</tr>
				</tbody>
			</table>
			
			<loading [isLoad]="disturbLoader"></loading>
		</div>
	